import _orderBy from 'lodash/orderBy';
import _uniqBy from 'lodash/uniqBy';
import moment from 'moment';

class SearchUtils {
    getRoomTypesSorted(roomTypesOptions) {
        let roomTypeOrdered = [];

        if (typeof roomTypesOptions !== 'undefined') {
            roomTypesOptions.map((room) => {
                switch (room.name) {
                    case 'Single':
                        roomTypeOrdered.push({
                            ...room,
                            order: 3
                        });
                        break;
                    case 'Double for Single Use': 
                        roomTypeOrdered.push({
                            ...room,
                            order: 4
                        });
                        break;
                    case 'Twin for Single Use':
                        roomTypeOrdered.push({
                            ...room,
                            order: 5
                        });
                        break;
                    case 'Double':
                        roomTypeOrdered.push({
                            ...room,
                            order: 1
                        });
                        break;
                    case 'Twin':
                        roomTypeOrdered.push({
                            ...room,
                            order: 2
                        });
                        break;
                    case 'Triple':
                        roomTypeOrdered.push({
                            ...room,
                            order: 6
                        });
                        break;
                    default:
                        roomTypeOrdered.push({
                            ...room,
                            order: 7
                        });
                        break;
                }
            });
        }
        return _orderBy(_uniqBy(roomTypeOrdered, 'name'), [ 'order' ]);
    }

    findCancellation(cancellationRules, date) {
        let result = cancellationRules.find((rule) => {
            let bookingDate = moment(date);
            return (
                bookingDate.isBetween(moment(rule.from), moment(rule.to), 'day', '[]') &&
                rule.days.split(',').includes(bookingDate.format('dd'))
            );
        });
        return result;
    }
}

export default SearchUtils;
